import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import cx from 'classnames'
import styles from './combinedRatingFilter.module.scss'
import { ReactComponent as IconTick } from 'images/icons/icn_confidence_tick.svg'

const ConfidenceModalContent = () => {
  const { t } = useTranslation('strFilters')
  return (
    <section className={styles.content}>
      <p>
        <Trans ns={'strFilters'} i18nKey={'confidenceModal.subtitle'}>
          Your number has a verification tick, this relates to degree of confidence
        </Trans>
      </p>
      <div className={styles.featureContainer}>
        <article className={styles.feature}>
          <div className={styles.featureCard}>
            <header className={styles.featureCard__header}>
              <h3>
                <Trans ns={'strFilters'} i18nKey={'confidenceModal.featureConfidenceHigh.title'}>
                  Confident
                </Trans>
              </h3>
            </header>
            <div className={styles.featureCard__body}>
              <p className={styles.featureCard__numberContainer}>
                <span
                  className={styles.featureCard__number}
                  aria-label={t('confidenceModal.ariaLabel.exampleNumber')}
                >
                  24<span>.5</span>
                </span>
                <IconTick
                  className={cx(styles.confidenceTick, styles.high)}
                  aria-label={t('confidenceModal.ariaLabel.tickHigh')}
                />
              </p>
            </div>
          </div>
          <ul>
            <li>
              <Trans ns={'strFilters'} i18nKey={'confidenceModal.featureConfidenceHigh.items.1'}>
                We have <b>lots of results</b> for you so have a better understanding of your
                ability
              </Trans>
            </li>
            <li>
              <Trans ns={'strFilters'} i18nKey={'confidenceModal.featureConfidenceHigh.items.2'}>
                You can be <b>confident your Number is accurate</b>
              </Trans>
            </li>
          </ul>
        </article>
        <article className={styles.feature}>
          <div className={styles.featureCard}>
            <header className={styles.featureCard__header}>
              <h3>
                <Trans ns={'strFilters'} i18nKey={'confidenceModal.featureConfidenceLow.title'}>
                  More data required
                </Trans>
              </h3>
            </header>
            <div className={styles.featureCard__body}>
              <p className={styles.featureCard__numberContainer}>
                <span
                  className={styles.featureCard__number}
                  aria-label={t('confidenceModal.ariaLabel.exampleNumber')}
                >
                  24<span>.5</span>
                </span>
                <IconTick
                  className={cx(styles.confidenceTick, styles.low)}
                  aria-label={t('confidenceModal.ariaLabel.tickLow')}
                />
              </p>
            </div>
          </div>
          <ul>
            <li>
              <Trans ns={'strFilters'} i18nKey={'confidenceModal.featureConfidenceLow.items.1'}>
                We need <b>more recent results</b> for you in order to better understand your
                ability
              </Trans>
            </li>
            <li>
              <Trans ns={'strFilters'} i18nKey={'confidenceModal.featureConfidenceLow.items.2'}>
                Your number may <b>not be as accurate as it could be</b>
              </Trans>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default ConfidenceModalContent
